export default __webpack_public_path__ + "static/media/viber_image_2022-06-02_17-48-46-060.ddac43cf.jpg";